import { createFileRoute, redirect, Link } from "@tanstack/react-router";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Eyebrow } from "@/components/brand/Eyebrow";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { myPurchaseHistory } from "@/lib/store-admin.functions";
import { supabase } from "@/integrations/supabase/client";
import { formatPrice } from "@/lib/store";

export const Route = createFileRoute("/store/library/orders")({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getUser();
    if (!data.user) throw redirect({ to: "/login" });
  },
  component: OrdersPage,
});

function OrdersPage() {
  const fetchHistory = useServerFn(myPurchaseHistory);
  const { data, isLoading } = useQuery({
    queryKey: ["store", "library", "orders"],
    queryFn: () => fetchHistory(),
  });

  return (
    <div className="min-h-screen bg-cream-50">
      <Navbar />
      <section className="mx-auto max-w-4xl px-6 py-20">
        <Link
          to="/store/library"
          className="font-sans text-xs uppercase tracking-[0.22em] text-bronze-600"
        >
          ← Back to Library
        </Link>
        <Eyebrow>Receipts</Eyebrow>
        <h1 className="mt-4 font-serif text-4xl text-navy-900">Purchase History</h1>

        {isLoading ? (
          <p className="mt-10 font-sans text-charcoal-500">Loading…</p>
        ) : !data || data.length === 0 ? (
          <p className="mt-10 rounded-sm border border-bronze-600/30 bg-white p-12 text-center font-sans text-charcoal-500">
            No completed orders yet.
          </p>
        ) : (
          <ul className="mt-10 space-y-6">
            {data.map((o) => (
              <li
                key={o.id}
                className="rounded-sm border border-bronze-600/20 bg-white p-6"
              >
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <p className="font-sans text-[10px] uppercase tracking-[0.22em] text-charcoal-500">
                      Order {o.id.slice(0, 8)}
                    </p>
                    <p className="mt-1 font-sans text-sm text-charcoal-500">
                      {o.paid_at
                        ? new Date(o.paid_at).toLocaleDateString()
                        : new Date(o.created_at).toLocaleDateString()}
                    </p>
                  </div>
                  <p className="font-mono text-lg text-navy-900">
                    {formatPrice(o.total_cents)}
                  </p>
                </div>
                <ul className="mt-4 divide-y divide-bronze-600/20 border-t border-bronze-600/20">
                  {(o.items ?? []).map((it, i) => (
                    <li
                      key={i}
                      className="flex items-center justify-between py-3 font-sans text-sm"
                    >
                      <span className="text-navy-900">{it.product_title_snapshot}</span>
                      <span className="font-mono text-charcoal-500">
                        {formatPrice(it.price_cents_snapshot)}
                      </span>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        )}
      </section>
      <Footer />
    </div>
  );
}